/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const CREATE_WIDGET = gql`
    mutation createWidget($payload: CreateWidgetInput) {
        createWidget(payload: $payload) {
            id
            name
            description
        }
    }
`;

export const PERSIST_WIDGET_PERMISSIONS = gql`
    mutation persistWidgetPermissions($widgetId: String, $permissions: [CreateWidgetPermissionInput]) {
        persistWidgetPermissions(widgetId: $widgetId, permissions: $permissions) {
            id
            userAccountId
            groupId
            widget {
                id
            }
        }
    }
`;

export const DELETE_WIDGET = gql`
    mutation deleteWidget($id: String) {
        deleteWidget(id: $id) {
            id
        }
    }
`;

export const CREATE_NOTIFICATION = gql`
    mutation createNotification($payload: CreateNotificationInput) {
        createNotification(payload: $payload) {
            id
            title
            description
            detailDescription
            imageLink
            showDetailView
            showFeedbackVoting
            showFeedbackField
            notificationType {
                id
                name
                color
            }
            publishedAt
            createdAt
        }
    }
`;

export const UPDATE_NOTIFICATION = gql`
    mutation updateNotification($id: String, $payload: UpdateNotificationInput) {
        updateNotification(id: $id, payload: $payload) {
            id
            title
            description
            detailDescription
            imageLink
            showDetailView
            showFeedbackVoting
            showFeedbackField
            notificationType {
                id
                name
                color
            }
            publishedAt
            createdAt
        }
    }
`;

export const TOGGLE_NOTIFICATION_PUBLISHED = gql`
    mutation toggleNotificationPublished($id: String) {
        toggleNotificationPublished(id: $id) {
            id
            publishedAt
        }
    }
`;

export const DELETE_NOTIFICATION = gql`
    mutation deleteNotification($id: String) {
        deleteNotification(id: $id) {
            id
        }
    }
`;

export const UPDATE_WIDGET_CONFIG = gql`
    mutation updateWidgetConfig($payload: UpdateWidgetConfigInput) {
        updateWidgetConfig(payload: $payload) {
            id
            widgetId
            jiraServiceDeskId
            jiraIssueTypeId
        }
    }
`;
